import { useAppState } from "./use-app-state"

// const IS_ADMIN_OR_PROCESSOR = "flag:isAdmin"

export const useFeature = (flag?: string) => {
  const { user } = useAppState()
  const isAdmin = user?.role === "admin"
  const isProcessor = user?.role === "processor"
  const isAdminOrProcessor = isAdmin || isProcessor

  return { isAdmin, isProcessor, isAdminOrProcessor }
}
